import axios from "../axiosInstance";
import { EnrollCourseRequestParams, EnrollCourseResponse } from "./types";

export const enrollCourse = async (
  params: EnrollCourseRequestParams,
): Promise<EnrollCourseResponse> => {
  const response = await axios.post<any>(
    `/api/learning-center/courses/${params.id}/enroll`,
  );

  const data = response.data;

  // Transform backend response to frontend format
  return {
    enrollment: {
      id: parseInt(data.enrollment.id, 10),
      courseId: parseInt(data.enrollment.course_id || params.id, 10),
      userId: parseInt(data.enrollment.user_id || '0', 10),
      status: data.enrollment.status,
      progressPercentage: data.enrollment.progress_percentage || 0,
      lastAccessedModuleId: null,
      enrolledAt: data.enrollment.started_at || new Date().toISOString(),
      completedAt: data.enrollment.completed_at || null,
      cancelledAt: null,
      createdAt: data.enrollment.started_at || new Date().toISOString(),
      updatedAt: data.enrollment.last_accessed_at || new Date().toISOString(),
    }
  };
};